export default __webpack_public_path__ + "static/media/Hemkunskap3.62bf484a.jpeg";